/**
 * GuardZoneList — CRUD des zones de garde
 * Permet de créer/modifier des zones géographiques de garde
 */
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  required,
  TopToolbar,
  CreateButton,
  EditButton,
  DeleteButton,
} from 'react-admin';

function GuardZoneActions() {
  return (
    <TopToolbar>
      <CreateButton label="Nouvelle zone" />
    </TopToolbar>
  );
}

export function GuardZoneList() {
  return (
    <List
      title="Zones de garde"
      actions={<GuardZoneActions />}
      empty={
        <div style={{ textAlign: 'center', padding: 40 }}>
          <p style={{ fontSize: 40 }}>📍</p>
          <p>Aucune zone de garde créée</p>
        </div>
      }
    >
      <Datagrid>
        <TextField source="name" label="Nom" />
        <TextField source="city" label="Ville" />
        <TextField source="country" label="Pays" />
        <NumberField source="centerLat" label="Lat" options={{ maximumFractionDigits: 4 }} />
        <NumberField source="centerLng" label="Lng" options={{ maximumFractionDigits: 4 }} />
        <NumberField source="radiusKm" label="Rayon (km)" />
        <DateField source="createdAt" label="Créée le" />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
}

export function GuardZoneCreate() {
  return (
    <Create title="Créer une zone de garde">
      <SimpleForm>
        <TextInput source="name" label="Nom de la zone" validate={required()} fullWidth />
        <TextInput source="city" label="Ville" validate={required()} fullWidth />
        <TextInput source="country" label="Pays" validate={required()} fullWidth />
        <TextInput source="description" label="Description" multiline rows={3} fullWidth />
        <NumberInput source="centerLat" label="Latitude du centre" fullWidth />
        <NumberInput source="centerLng" label="Longitude du centre" fullWidth />
        <NumberInput source="radiusKm" label="Rayon en km" fullWidth />
      </SimpleForm>
    </Create>
  );
}

export function GuardZoneEdit() {
  return (
    <Edit title="Modifier la zone de garde">
      <SimpleForm>
        <TextInput source="name" label="Nom de la zone" validate={required()} fullWidth />
        <TextInput source="city" label="Ville" validate={required()} fullWidth />
        <TextInput source="country" label="Pays" validate={required()} fullWidth />
        <TextInput source="description" label="Description" multiline rows={3} fullWidth />
        <NumberInput source="centerLat" label="Latitude du centre" fullWidth />
        <NumberInput source="centerLng" label="Longitude du centre" fullWidth />
        <NumberInput source="radiusKm" label="Rayon en km" fullWidth />
      </SimpleForm>
    </Edit>
  );
}
